import { render, staticRenderFns } from "./chartEncargos.vue?vue&type=template&id=20b35bf9&"
import script from "./chartEncargos.vue?vue&type=script&lang=js&"
export * from "./chartEncargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports